import { ref, computed } from "vue";
import { useStore } from "@/store";
const store = useStore();
const activeRowModal: any = ref({ data: null });
import { GeneralActionTypes } from "@/store/modules/general/action-types";

function getRegistryHiveById(value: number): string | undefined {
    const registryHives = computed(() => store.state.general.enums['RegistryHive'] || [])
    const folder = registryHives.value.find((item: any) => item.value === value);
    return folder?.label;
}
function getAppliesToById(value: number): string | undefined {
    const appliesToOptions = computed(() => store.state.general.enums['AppliesTo'] || [])
    const folder = appliesToOptions.value.find((item: any) => item.value === value);
    return folder?.label;
}
function getAccessControlById(value: number): string | undefined {
    const accessControlOptions = computed(() => store.state.general.enums['AccessControl'] || [])
    const folder = accessControlOptions.value.find((item: any) => item.value === value);
    return folder?.label;
}
function getAccessControlStyle(value: number) {
    const label = (getAccessControlById(value) || '').toLowerCase();

    let color = '#1677FF';
    let bg = '#1677FF33';

    if (label.includes('deny') || label.includes('block')) {
        color = '#E04C4D';
        bg = '#DE323229';
    } else if (label.includes('read/write')) {
        color = '#0C7EC5';
        bg = '#01AAF342';
    } else if (label.includes('read only')) {
        color = '#3461D3';
        bg = '#D3E0FF';
    } else if (label.includes('exclusive write')) {
        color = '#31AA06';
        bg = '#35B90733';
    }
    else if (label.includes('exclusive access')) {
        color = '#31AA06';
        bg = '#35B90733';
    }

    return { color, bg };
}
const data = {
    filter: {
        title: "registryAccessfilter",
        pageName: "registryAccessfilter",
        genre: "registryAccessPageFilter",
        ignoreSaveFilter: true,
        noDateSelect: true,
        hideFilter: false,
        //quickSearch: "fullTextSearch",
        filters: [
        ],
    },
    header: {
        navigation: [

        ],
        buttonPosition: "pr-4 justify-content-between",
        buttons: [

        ],
    },
    component: {
        type: "ag-table",
        options: {
            columns: [
                {
                    label: "REGISTRY KEY",
                    field: "registryKey",
                    sortable: false,
                    display: (row: any) => {
                        const truncateMiddle = (input: string, max = 50): string => {
                            const str = (input || "").toString();
                            if (str.length <= max) return str;
                            return str.slice(0, max) + "...";
                        };
                        let registryHive = null;
                        const registryKey = row.registryKey || "";
                        if (row.registryHive) {
                            registryHive = getRegistryHiveById(row.registryHive);
                        }
                        const hiveLabel = String(registryHive || '');
                        const lower = hiveLabel.toLowerCase();
                        let iconClass = 'ag-icon_hkey_local_machine';
                        if (lower.includes('current') && lower.includes('user') && lower.includes('classes')) {
                            iconClass = 'ag-icon_hkey_current_user_classes';
                        } else if (lower.includes('current') && lower.includes('user')) {
                            iconClass = 'ag-icon_hkey_current_user';
                        } else if (lower.includes('users')) {
                            iconClass = 'ag-icon_hkey_users';
                        } else if (lower.includes('local') && lower.includes('machine')) {
                            iconClass = 'ag-icon_hkey_local_machine';
                        }else if (lower.includes('current') && lower.includes('config')) {
                            iconClass = 'ag-icon_hkey_current_config';
                        }else if (lower.includes('classes') && lower.includes('root')) {
                            iconClass = 'ag-icon_hkey_classes_root';
                        }

                        let html = "<div class='d-flex flex-column align-items-start'>";
                        const truncatedRegistryKey = truncateMiddle(registryKey, 50);
                        html += `<div class='d-flex align-items-center'><i class='ag-icon ${iconClass}' style='width:16px;height:19px;margin-right:8px;'></i><span style='color: #01172F; font-weight: bold;'>${hiveLabel}</span></div>`;
                        html += "<span style='color: #01172F; font-size:0.78em; margin-left:24px'>" + truncatedRegistryKey + "</span>";

                        if (row.enabled === false) {
                            html += "<div class='d-flex align-items-center' style='margin-top:10px;margin-left:24px'><i class='ag-icon ag-icon_warning_filled' style='font-size:0.8em !important;'></i><span style='font-size:0.7em; color:#636363; margin-left:6px'>This rule is disabled and will not be published</span></div>";
                        }
                        html += "</div>";
                        return html;
                    },
                    width: "35%",
                },
                {
                    label: "REGISTRY VALUE",
                    field: "registryValue",
                    sortable: true,
                    jsSort: true,
                    display: (row: any) => {
                        const truncateMiddle = (input: string, max = 70): string => {
                            const str = (input || "").toString();
                            if (str.length <= max) return str;
                            return str.slice(0, max) + "...";
                        };
                        const registryValue = row.registryValue ?? "";
                        return `<span style='color: #01172F;'>${truncateMiddle(registryValue)}</span>`;
                    },
                    width: "15%",
                },
                {
                    label: "ACCESS CONTROL",
                    field: "accessControl",
                    display: (row: any) => {
                        const accessControl = row.accessControl ? getAccessControlById(row.accessControl) : "";
                        const styles = row.accessControl != null ? getAccessControlStyle(row.accessControl) : { color: '#1677FF', bg: '#1677FF33' };
                        return `
                            <span style='margin-left:8px;background:${styles.bg};color:${styles.color};border-radius:16px;padding:2px 8px;font-weight:700;font-size:12px;display:inline-flex;align-items:center;'>
                                ${accessControl}
                            </span>`;
                    },
                    sortable: true,
                    jsSort: true,
                    width: "15%",
                },
                {
                    label: "APPLIES TO",
                    field: "appliesTo",
                    display: (row: any) => {
                        const appliesTo =row.appliesTo ? getAppliesToById(row.appliesTo) : "";
                        return `<span style='color: #01172F;'>${appliesTo}</span>`;
                    },
                    sortable: true,
                    jsSort: true,
                    width: "15%",
                },
                {
                    label: "ACTION",
                    field: "commands",
                    justify: 'justify-content-center',
                    style: { justifyItems: 'center' },
                    components: [
                        {
                            component: "appGroupTableEditComponent",
                        },
                        {
                            component: "copyAction",
                            class: "mr-2 ml-2",
                        },
                        {
                            component: "appGroupDeleteComponent",
                        },
                    ],
                    width: "120px",
                
                },
            ],
            rows: [],
            total: 0,
            sortable: {
                order: "",
                sort: "asc",
            },
            page: 0,
            pageSize: 0,
            showPagination: false,
            isLoading: true,
            dateFilter: false,
            zebra: true,
            separateBorders: true,
            editOnRowClick: true,
            fetchTable: (options: any) => {
                store.dispatch(GeneralActionTypes.GET_APPGROUP_REGISTRY, {
                    options: options,
                    filters: {}
                });
            }
        },
    },

};

export default data;
